import { render, staticRenderFns } from "./EditOverlay.vue?vue&type=template&id=3ee13b95&scoped=true&"
import script from "./EditOverlay.vue?vue&type=script&lang=ts&"
export * from "./EditOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./EditOverlay.vue?vue&type=style&index=0&id=3ee13b95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee13b95",
  null
  
)

export default component.exports